export default __webpack_public_path__ + "static/media/paramsIcon.346b7cbb.svg";